import { downloadFile, getJSON, post } from "../../http";
import { MapDataGroup, MapDataGroupId, MapDataSource, MapDataSourceId, MapDataSourceType } from '../models/MapDataSource';
import { MapDimension } from "../models/MapDimension";
import { MapExportQuery } from "../models/MapExportQuery";


export class MapAPIService {
  private _cache = new Map<string, Promise<unknown>>();
  constructor(private baseURL: string, private baseV2URL: string) {

  }

  async getDataSources() {
    const url = `${this.baseURL}/datasources`;
    const request = this._cache.has(url) ? this._cache.get(url)! : getJSON<Record<string, unknown>[]>(url);
    if (!this._cache.has(url)) {
      this._cache.set(url, request);
    }
    const response = await request as Record<string, unknown>[];
    const result: (MapDataGroup | MapDataSource)[] = [];
    response.forEach(data => {
      const hasParent = Boolean(data['parentId']);
      if (hasParent) {
        result.push(MapDataSource.fromDTO(data));
      } else {
        result.push(MapDataGroup.fromDTO(data));
      }
    });
    const groups = result.filter(e => e instanceof MapDataGroup) as MapDataGroup[];
    const datasources = result.filter(e => e instanceof MapDataSource) as MapDataSource[];
    groups.forEach(group => datasources.filter(e => e.groupId === group.id).forEach(e => group.addSource(e)));
    return result;
  }

  async getDataSourceDimensions(dataSourceId: number | string) {
    const url = `${this.baseURL}/dimensions/${dataSourceId}`;
    const request = this._cache.has(url) ? this._cache.get(url)! : getJSON<Record<string, unknown>[]>(url);
    if (!this._cache.has(url)) {
      this._cache.set(url, request);
    }
    const response = await request as Record<string, unknown>[];
    const result: MapDimension[] = response.map(data => MapDimension.fromDTO(data));
    return result;
  }

  async export(type: 'xlsx' | 'pptx', model: MapExportQuery) {
    const useReportingV2 = type === "xlsx";
    const url = `${useReportingV2 ? this.baseV2URL : this.baseURL}/export/${type}`;
    const result = await post(url, model.toDTO(useReportingV2));
    const blob = await result.blob();
    const filename = result.headers
      .get("Content-Disposition")!
      .split("; ")
      .find((x) => x.includes("filename*=UTF-8''"))!
      .split("''")[1];
    downloadFile(blob, decodeURIComponent(filename));
  }
}